import React from "react";

const CaseDetailsSectionLatestMobile = ({
  service,
  lang,
  arPhrase,
  enPhrase,
}) => {
  const {
    id,
    serviceCategory,
    status,
    caseNumber,
    requesterEmail,
    requesterName,
    caseTypeName,
    createdAt,
    contactNumber,
    contactEmail,
    courtName,
    partyTypeName,
    caseYear,
  } = service;
  return (
    <div className="w-full">
      <div className="flex flex-col items-start justify-center">
        <div className="w-full bg-white grid grid-cols-1 sm:grid-cols-2 gap-4 xl:gap-y-8 xl:gap-x-3">
          <div className="flex flex-row gap-2 items-start">
            <p className="text-[14px] font-normal text-[#010202]">
              {lang === "en" ? enPhrase["lblCase"] : arPhrase["lblCase"]}
            </p>
            <p
              className="max-w-[100px] text-sm font-[500] font-Almarai text-[#010202] overflow-hidden text-ellipsis whitespace-nowrap text-left"
              style={{ direction: "rtl", unicodeBidi: "plaintext" }}
            >
              {caseNumber}
            </p>
            <p className="text-[14px] font-bold">•</p>
            <p className="text-sm font-[500] text-[#010202] ">{caseTypeName}</p>
          </div>
          <div className="flex flex-row gap-2 items-start ">
            <p className="text-[14px] font-normal text-[#737373]">
              {lang === "en" ? enPhrase["lblCourt"] : arPhrase["lblCourt"]}
            </p>
            <p className="text-sm font-normal text-[#010202]">{courtName}</p>
          </div>

          <div className="flex flex-row gap-2 items-start">
            <p
              className={`text-[14px] font-normal text-[#737373]  ${lang === "en" ? "w-[62px]" : ""}`}
            >
              {lang === "en"
                ? enPhrase["lblCustomerStatus"]
                : arPhrase["lblCustomerStatus"]}
            </p>
            <p className="text-sm font-normal text-[#010202] break-all max-w-[240px] ">
              {partyTypeName}
            </p>
          </div>

          <div className="flex flex-row gap-2 items-start ">
            <p className="text-[14px] font-normal text-[#737373]">
              {lang === "en" ? enPhrase["lblYear"] : arPhrase["lblYear"]}
            </p>
            <p className="text-sm font-normal text-[#010202]">{caseYear}</p>
          </div>

          {contactNumber && (
            <div className="flex flex-row gap-2 items-start">
              <p className="text-[14px] font-normal text-[#737373]">
                {lang === "en" ? enPhrase["lblPhone"] : arPhrase["lblPhone"]}
              </p>
              <p
                className={`text-sm font-normal text-[#010202] ${
                  lang === "en" ? "" : "text-right"
                } `}
                dir="ltr"
              >
                {contactNumber}
              </p>
            </div>
          )}

          {contactEmail && (
            <div className="flex flex-row gap-2 items-start ">
              <p className={`text-[14px] font-normal text-[#6F6A62] ${lang === "en" ? " w-[42px] ":" w-[90px] "}`}>
              
                {lang === "en" ? enPhrase["lblEmail"] : arPhrase["lblEmail"]}:
              </p>
              <p className="text-sm font-normal font-Almarai text-[#010202] break-all max-w-[240px]">
                {contactEmail}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseDetailsSectionLatestMobile;
